import { TuckshopContext } from '../context/TuckshopContext'
import { useContext } from 'react'

export const useTuckshopContext = ()=> {
    const context = useContext(TuckshopContext)

    if (!context){
        throw Error('useTuckshopContext must be inside an WorkoutsContextProvider')
    }
    return context
}
